module.exports = __webpack_public_path__ + "static/media/OfferBook_ios_4_preview.4822a3db.jpg";